import React, { useEffect, useRef, useState } from 'react';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { useLang, LANGUAGES } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen(!open)}
        data-testid="lang-switcher-button"
        className={`flex items-center gap-1.5 ${compact ? 'px-2.5 py-2 text-[11px]' : 'px-3 py-2.5 text-xs'} text-gray-700 hover:text-green-700 bg-white border border-gray-300 hover:border-green-500 rounded transition-colors font-bold uppercase tracking-wider`}
        aria-label={t('selectLanguage')}
      >
        <Globe className="w-3.5 h-3.5" />
        <span>{current.code.toUpperCase()}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-[#1a1f2e] border border-gray-900/60 rounded-md shadow-2xl shadow-black/60 z-50 overflow-hidden" data-testid="lang-switcher-menu">
          <div className="px-4 py-3 text-[10px] text-orange-400 font-bold uppercase tracking-[0.2em] border-b border-gray-900/40">{t('selectLanguage')}</div>
          <div className="max-h-80 overflow-y-auto">
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                data-testid={`lang-option-${l.code}`}
                className={`w-full flex items-center justify-between gap-2 px-4 py-2.5 text-[13px] text-left transition-colors ${l.code === lang ? 'bg-gray-900/30 text-green-300' : 'text-gray-300 hover:bg-gray-900/20 hover:text-green-400'}`}
              >
                <span className="flex items-center gap-2.5">
                  <span className="text-[10px] font-bold text-gray-500 w-6">{l.code.toUpperCase()}</span>
                  <span>{l.name}</span>
                </span>
                {l.code === lang && <Check className="w-3.5 h-3.5 text-green-400" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
